import React from 'react';
import CoheteImage from '../../assets/images/financing-request/bannerPreaprobado.svg';
import {  formatDateHour } from '../../utils/format';

const FormSeguro = ({cacheCredit}) => {
  console.log(cacheCredit);
  
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="relative mb-5">
        <div className="px-12 pb-4 dark:opacity-50">
          <img src={CoheteImage} alt="cohete" />
        </div>
      </div>
        <div className=" w-full text-center">
          <p className="font-bold text-2xl">
          {cacheCredit.estudiante.nombre + ' ' + cacheCredit.estudiante.apellido}
          </p>
          <p className="font-bold text-1xl">
              Tu solicitud de financiación fue
          </p>
          <p className="text-5xl font-bold text-pink-700 mt-1 mb-1">¡PREAPROBADA!</p>

          <p className="font-bold mt-2">Institución:</p>
          <p >{cacheCredit.universidad}</p>
          
          <p className="font-bold mt-2">Nombre del programa:</p>
          <p >{cacheCredit.programa}</p>
          
          <p className="font-bold mt-2">Línea de financiación:</p>
          <p >{cacheCredit.linea}</p>
          
          <p className="font-bold mt-2 ">Fecha del resultado:</p>
          <p className='mb-2'>{formatDateHour(cacheCredit.estado.createdAt, { showHour: true, })}</p>

        </div>
      <p className="text-1xl font-bold text-[#E7496C] mt-1 mb-2">
      Ha llegado el momento de completar la última etapa de firmas y legalización. <br />
      Es fundamental finalizar todo el proceso en las próximas 24 horas para evitar cancelaciones.
      </p>
    </div>
  );
};

export default FormSeguro;
